export default function PropertyShowcase() {
  const properties = [
    {
      image: 'https://public.readdy.ai/ai/img_res/e48f6fc121f8a8745ab074ad44a10b52.jpg',
      location: 'West El Paso, TX',
      type: 'Single Family Home',
      beds: 4,
      baths: 3,
      sqft: '2,850',
      soldPrice: '$225,000',
      timeline: 'Closed in 10 days',
      situation: 'Inherited Property'
    },
    {
      image: 'https://readdy.ai/api/search-image?query=contemporary%20townhouse%20exterior%20in%20El%20Paso%20Texas%20with%20modern%20architecture%20clean%20lines%20simple%20background%20real%20estate%20investment%20property%20photography&width=800&height=600&seq=prop-elpaso-002&orientation=landscape',
      location: 'East El Paso, TX',
      type: 'Townhouse',
      beds: 3,
      baths: 2.5,
      sqft: '2,100',
      soldPrice: '$129,000',
      timeline: 'Closed in 7 days',
      situation: 'Quick Relocation'
    },
    {
      image: 'https://readdy.ai/api/search-image?query=luxury%20home%20exterior%20in%20El%20Paso%20Texas%20with%20mountain%20views%20and%20blue%20sky%20simple%20clean%20background%20high%20end%20residential%20real%20estate%20property&width=800&height=600&seq=prop-elpaso-003&orientation=landscape',
      location: 'Upper Valley, TX',
      type: 'Mountain View Home',
      beds: 5,
      baths: 4,
      sqft: '3,500',
      soldPrice: '$135,000',
      timeline: 'Closed in 14 days',
      situation: 'Divorce Settlement'
    },
    {
      image: 'https://readdy.ai/api/search-image?query=charming%20bungalow%20house%20exterior%20in%20El%20Paso%20Texas%20neighborhood%20with%20desert%20plants%20simple%20background%20fixer%20upper%20investment%20property%20real%20estate&width=800&height=600&seq=prop-elpaso-004&orientation=landscape',
      location: 'Downtown El Paso, TX',
      type: 'Bungalow',
      beds: 3,
      baths: 2,
      sqft: '1,650',
      soldPrice: '$105,000',
      timeline: 'Closed in 22 days',
      situation: 'As-Is Condition'
    },
    {
      image: 'https://static.readdy.ai/image/4f005a6d9d587cd5cd5ab19a1efc7d16/8ad4567ed7c08e2447ab58f2b0002ce9.jpeg',
      location: 'Downtown El Paso, TX',
      type: 'Duplex',
      beds: 2,
      baths: 2,
      sqft: '1,400',
      soldPrice: '$100,000',
      timeline: 'Closed in 9 days',
      situation: 'Foreclosure Prevention'
    },
    {
      image: 'https://readdy.ai/api/search-image?query=spacious%20ranch%20style%20home%20exterior%20in%20El%20Paso%20Texas%20suburbs%20with%20large%20yard%20desert%20landscaping%20simple%20background%20family%20residential%20property%20real%20estate&width=800&height=600&seq=prop-elpaso-006&orientation=landscape',
      location: 'Northeast El Paso, TX',
      type: 'Ranch Home',
      beds: 4,
      baths: 3,
      sqft: '2,400',
      soldPrice: '$75,000',
      timeline: 'Closed in 31 days',
      situation: 'Rental Property Sale'
    }
  ];

  return (
    <section id="properties" className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <div className="inline-block px-4 py-2 bg-teal-100 text-teal-700 rounded-full text-sm font-semibold mb-6">
            Recent Purchases
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6 leading-tight" style={{ fontFamily: 'Poppins, sans-serif' }}>
            Properties We've <strong>Recently Purchased</strong>
          </h2>
          <p className="text-xl text-gray-600 leading-relaxed">
            See real examples of homes we've bought from El Paso homeowners just like you. Every property has a unique story, and we're here to help write yours.
          </p>
        </div>

        {/* Properties Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {properties.map((property, index) => (
            <div 
              key={index}
              className="bg-white rounded-xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 group"
            >
              <div className="relative overflow-hidden">
                <div className="w-full h-64">
                  <img
                    src={property.image}
                    alt={`${property.type} in ${property.location}`}
                    className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
                  />
                </div>
                <div className="absolute top-4 left-4 bg-teal-600 text-white px-4 py-2 rounded-lg font-bold text-sm">
                  {property.soldPrice}
                </div>
                <div className="absolute top-4 right-4 bg-white/90 backdrop-blur-sm text-gray-900 px-3 py-1 rounded-full text-xs font-semibold">
                  {property.timeline}
                </div>
              </div>

              <div className="p-6">
                <div className="flex items-center space-x-2 text-teal-600 mb-2">
                  <i className="ri-map-pin-fill"></i>
                  <span className="font-semibold text-sm">{property.location}</span>
                </div>
                
                <h3 className="text-xl font-bold text-gray-900 mb-3">{property.type}</h3>
                
                <div className="flex items-center space-x-4 mb-4 text-sm text-gray-600">
                  <div className="flex items-center space-x-1">
                    <i className="ri-hotel-bed-fill"></i>
                    <span>{property.beds} Beds</span>
                  </div>
                  <div className="flex items-center space-x-1">
                    <i className="ri-drop-fill"></i>
                    <span>{property.baths} Baths</span>
                  </div>
                  <div className="flex items-center space-x-1">
                    <i className="ri-ruler-fill"></i>
                    <span>{property.sqft} sqft</span>
                  </div>
                </div>

                <div className="pt-4 border-t border-gray-100">
                  <div className="flex items-center space-x-2">
                    <i className="ri-checkbox-circle-fill text-green-500"></i>
                    <span className="text-sm text-gray-700 font-medium">{property.situation}</span>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Stats Section */}
        <div className="mt-16 grid grid-cols-2 md:grid-cols-4 gap-8">
          <div className="text-center">
            <div className="text-4xl font-bold text-teal-600 mb-2">200+</div>
            <div className="text-gray-600 font-medium">Homes Purchased</div>
          </div>
          <div className="text-center">
            <div className="text-4xl font-bold text-teal-600 mb-2">$150M+</div>
            <div className="text-gray-600 font-medium">Total Value</div>
          </div>
          <div className="text-center">
            <div className="text-4xl font-bold text-teal-600 mb-2">18 Days</div>
            <div className="text-gray-600 font-medium">Avg. Closing Time</div>
          </div>
          <div className="text-center">
            <div className="text-4xl font-bold text-teal-600 mb-2">98%</div>
            <div className="text-gray-600 font-medium">Satisfaction Rate</div>
          </div>
        </div>
      </div>
    </section>
  );
}